import { axios } from '@/utils/request'

/**
 * 养殖户列表
 *
 * @author kakayunmu
 */
export function FarmersPage(parameter) {
  return axios({
    url: '/AgricultureAttractFarmers/web/page',
    method: 'get',
    params: parameter
  })
}

/**
 * 种植户列表
 *
 * @author kakayunmu
 */
 export function PlantingLargePage(parameter) {
  return axios({
    url: '/AgricultureAttractPlantingLarge/web/page',
    method: 'get',
    params: parameter
  })
}

/**
 * 加工服务列表
 *
 * @author kakayunmu
 */
 export function ProcessingIndustryPage(parameter) {
  return axios({
    url: '/AgricultureAttractProcessingIndustry/web/page',
    method: 'get',
    params: parameter
  })
}

/**
 * 综合数据列表
 *
 * @author kakayunmu
 */
 export function SyntheticDataPage(parameter) {
  return axios({
    url: '/AgricultureAttractSyntheticData/web/page',
    method: 'get',
    params: parameter
  })
}

/**
 * 水利设施列表
 *
 * @author kakayunmu
 */
 export function WaterFacilityPage(parameter) {
  return axios({
    url: '/AgricultureAttractWaterFacility/web/page',
    method: 'get',
    params: parameter
  })
}
